<template>
  <div
    :id="`sovido-video-${productId}`"
    ref="sovido"
    class="sovido-video"
    :data-account="accountId"
    :data-embed-code="productIdentifier"
  />
</template>

<script>
export default {
  props: {
    productId: {
      required: true,
      type: String,
    },
  },
  computed: {
    accountId() {
      return useRuntimeConfig().public.sovidoAccountId;
    },
    productIdentifier() {
      return `${this.productId}-${useRuntimeConfig().public.sovidoProjectid}`;
    },
  },
  mounted() {
    const sovidoScriptExists = document.getElementById('sovido_script');

    if (sovidoScriptExists) {
      return;
    }

    const sovJsFile = useRuntimeConfig().public.sovidoJsFile;
    const script = document.createElement('script');
    script.id = 'sovido_script';
    script.async = true;
    script.src = sovJsFile;
    document.body.append(script);
  },
};
</script>
